// extracted by mini-css-extract-plugin
export default {"select":"Selectors_select__YzfFF"};